import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: localStorage.getItem('user') || '',
    model_id: localStorage.getItem('model_id') || '',
    model_name: localStorage.getItem('model_name') || '',
    model_name_slo: localStorage.getItem('model_name_slo') || '',
    model_git: localStorage.getItem('model_git') || '',
    language: localStorage.getItem('language') || 'ENG',
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, data){
      state.status = 'success'
      state.token = data.token
      state.user = data.user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = ''
      state.token = ''
      state.user = ''
    },
    save_model_id_success(state, model_id) {
      state.model_id = model_id
    },
    save_model_name_success(state, model_name) {
      state.model_name = model_name
    },
    save_model_name_slo_success(state, model_name_slo) {
      state.model_name_slo = model_name_slo
    },
    save_model_git_success(state, model_git) {
      state.model_git = model_git
    },
    save_language_success(state, language) {
      state.language = language
    }
  },
  actions: {
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: this._vm.$hostname + '/api/login', data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.auth_token
          const user = resp.data.email
          localStorage.setItem('token', token)
          localStorage.setItem('user', user)
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', {'token':token, 'user':user})
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error')
          reject(err);
        })
      })
    },
    register({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: this._vm.$hostname + '/api/register', data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.auth_token
          const user = resp.data.email
          localStorage.setItem('token', token)
          localStorage.setItem('user', user)
          axios.defaults.headers.common['Authorization'] = token
          commit('auth_success', {'token':token, 'user':user})
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error', err)
          reject(err);
        })
      })
    },
    logout({commit}, user){
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({url: this._vm.$hostname + '/api/logout', data: user, method: 'POST' })
        .then(resp => {
          // Logic moved below the catch to ensure it always runs
          resolve(resp);
        })
        .catch(err => {
          commit('auth_error', err)
          reject(err);
        })
        .finally(() => {
          // This runs regardless of success or failure
          localStorage.removeItem('token')
          localStorage.removeItem('user')
          delete axios.defaults.headers.common['Authorization']
          commit('logout')
        })
      })
    },
    save_model_id({commit}, model_id){
      commit('save_model_id_success', model_id)
      localStorage.setItem('model_id', model_id)
    },
    save_model_name({commit}, model_name){
      commit('save_model_name_success', model_name)
      localStorage.setItem('model_name', model_name)
    },
    save_model_name_slo({commit}, model_name_slo){
      commit('save_model_name_slo_success', model_name_slo)
      localStorage.setItem('model_name_slo', model_name_slo)
    },
    save_model_git({commit}, model_git){
      commit('save_model_git_success', model_git)
      localStorage.setItem('model_git', model_git)
    },
    save_language({commit}, language){
      commit('save_language_success', language)
      localStorage.setItem('language', language)
    },

  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    getUser: state => state.user,
    model_id: state => state.model_id,
    model_name: state => state.model_name,
    model_name_slo: state => state.model_name_slo,
    model_git: state => state.model_git,
    language: state => state.language,
  }
})